import { render, staticRenderFns } from "./water-sports-goa.vue?vue&type=template&id=3f3118ca&scoped=true"
import script from "./water-sports-goa.vue?vue&type=script&lang=js"
export * from "./water-sports-goa.vue?vue&type=script&lang=js"
import style0 from "./water-sports-goa.vue?vue&type=style&index=0&id=3f3118ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3118ca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainCategoryCard: require('/workspace/components/MainCategoryCard.vue').default,PopularCategoryCard: require('/workspace/components/PopularCategoryCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
